import { ClinicOrDoctorSearchResult } from 'all-in-one-shared-api';

const defaultDoctor: ClinicOrDoctorSearchResult = {
  id: '',
  licenseNo: '',
  name: '',
  chineseName: '',
};

export const findDoctorIdAndNameByQuery = (
  doctorDataResult: ClinicOrDoctorSearchResult[],
  doctorName: string,
): ClinicOrDoctorSearchResult => {
  if (!doctorName) return defaultDoctor;
  const doctor = doctorDataResult.find(
    (doctor) =>
      doctor.id === doctorName ||
      doctor?.name?.toLowerCase() === doctorName.toLowerCase() ||
      doctor?.chineseName?.toLowerCase() === doctorName.toLowerCase(),
  );
  return (
    doctor ?? {
      id: '',
      licenseNo: '',
      name: doctorName,
      chineseName: doctorName,
    }
  );
};

export const findDoctorIdAndNameByQueryByOcr = (
  doctorDataResult: ClinicOrDoctorSearchResult[],
  doctorName: string,
  doctorId: string,
  doctorDetails?: {
    doctorCode: string;
    doctorName: string;
    doctorChineseName: string;
  },
): ClinicOrDoctorSearchResult => {
  try {
    if (!doctorDetails?.doctorChineseName && !doctorDetails?.doctorName && !doctorId && !doctorName)
      return defaultDoctor;
    let doctor = undefined;
    if (doctorId) {
      doctor = doctorDataResult.find((doctor) => doctor.id === doctorId);
    }

    return (
      doctor ?? {
        id: doctorDetails?.doctorCode || '',
        licenseNo: '',
        name: doctorDetails?.doctorName || doctorName,
        chineseName: doctorDetails?.doctorChineseName || doctorName,
      }
    );
  } catch {
    return defaultDoctor;
  }
};
